var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7359,
    height: 2073,
    viewBox: "0 0 7359 2073",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_187)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2157.17 2013.36C2005.85 2013.36 1903.24 1703.12 1739.83 1169.01C1611.31 748.559 1435.12 172.298 1273.78 172.298C1112.44 172.298 949.375 674.281 832.948 1040.83C755.561 1285.09 682.319 1515.87 606.313 1630.22C500.251 1789.49 406.971 1790.53 347.203 1763.58C214.194 1703.47 143.37 1438.14 107.095 1226.36C67.3646 992.122 57.3457 741.304 83.9476 642.842C102.604 573.055 145.789 569.255 163.408 571.328L153.044 674.281C170.318 676.008 183.791 665.644 186.901 659.771C170.318 690.173 160.299 888.824 201.065 1160.72C241.486 1428.81 311.273 1622.62 382.788 1666.15C418.027 1687.57 464.321 1656.48 519.943 1573.22C588.003 1470.96 659.172 1247.09 734.141 1010.09C881.315 547.144 1032.98 69 1273.78 69C1494.89 69 1641.03 492.558 1838.64 1138.61C1904.63 1354.53 1967.16 1558.36 2028.65 1706.57C2115.02 1914.21 2158.9 1909.37 2159.25 1909.72L2176.17 2011.63C2169.61 2012.67 2163.39 2013.36 2157.17 2013.36Z",
    fill: "url(#paint0_linear_478_187)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M1975.11 1565.62C1929.16 1432.26 1910.16 1369.73 1910.16 1369.73L1834.84 1472.68C1834.84 1472.68 1866.28 1569.07 1893.58 1644.73L1975.11 1565.62Z",
    fill: "url(#paint1_linear_478_187)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M607.008 1392.19C555.532 1515.52 536.185 1549.38 536.185 1549.38L606.663 1630.22C648.811 1564.24 645.011 1560.09 681.286 1485.12L607.354 1392.19H607.008Z",
    fill: "url(#paint2_linear_478_187)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2160.98 2013.02V1909.72H2158.56C2216.94 1890.37 2345.12 1542.82 2337.17 1266.78C2334.41 1167.28 2311.26 1099.91 2276.71 1090.58C2224.89 1077.11 2147.5 1219.79 2090.84 1324.47C2000.67 1490.65 1907.74 1662.35 1761.95 1662.35C1563.99 1662.35 1489.36 1356.26 1417.16 1059.84C1384.34 925.099 1323.19 673.935 1273.78 673.935C1224.38 673.935 1164.27 914.044 1131.45 1042.91C1058.2 1333.11 975.289 1662.35 754.528 1662.35C556.222 1662.35 412.157 1298.56 285.366 977.958C234.926 850.821 172.394 692.246 142.337 670.481C142.337 670.481 146.138 673.244 153.047 673.935L163.412 570.982C235.617 578.237 279.493 682.918 381.41 939.955C472.962 1171.43 626.7 1559.05 754.528 1559.05C894.793 1559.05 970.453 1258.83 1031.26 1017.69C1094.48 767.906 1144.23 570.637 1273.78 570.637C1403.34 570.637 1454.12 775.852 1517.35 1035.31C1571.24 1256.41 1644.83 1558.71 1761.6 1558.71C1845.9 1558.71 1927.78 1407.73 1999.64 1274.72C2088.77 1110.62 2172.72 955.501 2302.97 990.395C2459.82 1032.2 2449.45 1295.45 2429.41 1448.5C2410.41 1594.64 2319.55 2012.32 2160.63 2012.32L2160.98 2013.02Z",
    fill: "url(#paint3_linear_478_187)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_478_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3212.71 1161.25H2923.36L2851.43 1365.16C2851.43 1365.16 2849.78 1367.14 2848.46 1367.14H2767.62C2765.64 1367.14 2763.99 1365.16 2764.65 1363.18L2991.32 716.824C2991.32 716.824 2992.97 714.845 2994.29 714.845H3141.78C3141.78 714.845 3144.09 715.504 3144.75 716.824L3371.42 1363.18C3372.07 1365.16 3370.76 1367.14 3368.45 1367.14H3287.61C3287.61 1367.14 3285.3 1366.48 3284.64 1365.16L3212.71 1161.25ZM3185 1082.07L3084.04 793.7H3052.03L2951.07 1082.07H3185.33H3185Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3528.8 702.97V1364.17C3528.8 1364.17 3527.48 1367.14 3525.83 1367.14H3448.95C3448.95 1367.14 3445.98 1365.82 3445.98 1364.17V702.97C3445.98 702.97 3447.3 700 3448.95 700H3525.83C3525.83 700 3528.8 701.32 3528.8 702.97Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3724.45 702.97V1364.17C3724.45 1364.17 3723.13 1367.14 3721.48 1367.14H3644.61C3644.61 1367.14 3641.64 1365.82 3641.64 1364.17V702.97C3641.64 702.97 3642.96 700 3644.61 700H3721.48C3721.48 700 3724.45 701.32 3724.45 702.97Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3828.05 780.836C3809.58 741.243 3839.27 700 3877.55 700C3907.9 700 3932.65 725.735 3932.65 756.09C3932.65 793.703 3894.7 821.418 3855.11 805.911C3843.23 801.292 3833.33 792.383 3828.05 780.836ZM3839.27 926.009H3915.49C3917.14 926.009 3918.79 927.329 3918.79 929.309V1363.84C3918.79 1365.49 3917.47 1367.14 3915.49 1367.14H3839.27C3837.62 1367.14 3835.97 1365.82 3835.97 1363.84V929.309C3835.97 927.659 3837.29 926.009 3839.27 926.009Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4011.18 1009.48C4011.18 806.571 4129.63 700 4286.02 700H4361.24C4471.44 700 4577.03 772.917 4606.72 907.203C4607.05 909.182 4605.73 911.162 4603.42 911.162H4521.6C4521.6 911.162 4518.96 910.172 4518.63 908.852C4495.86 832.966 4429.21 778.856 4323.63 778.856C4149.09 778.856 4093.99 891.036 4093.99 1016.74V1064.58C4093.99 1190.62 4149.09 1299.83 4323.63 1299.83C4438.12 1299.83 4505.1 1238.46 4524.24 1155.32C4524.24 1154 4525.89 1153.01 4527.2 1153.01H4606.39C4608.37 1153.01 4610.02 1154.99 4609.69 1156.97C4586.26 1305.11 4477.71 1381.99 4361.24 1381.99H4286.02C4129.96 1381.99 4011.18 1275.42 4011.18 1072.5V1010.14V1009.48Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5109.22 1111.77V1181.71C5109.22 1318.64 5019.14 1381.99 4915.21 1381.99H4861.76C4757.83 1381.99 4667.76 1318.64 4667.76 1181.71V1111.77C4667.76 974.841 4757.83 911.492 4861.76 911.492H4915.21C5019.14 911.492 5109.22 974.841 5109.22 1111.77ZM5026.73 1126.28C5026.73 1043.47 4993.74 990.348 4888.82 990.348C4783.89 990.348 4750.9 1043.8 4750.9 1126.28V1166.54C4750.9 1249.35 4783.89 1302.47 4888.82 1302.47C4993.74 1302.47 5026.73 1249.02 5026.73 1166.54V1126.28Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5566.18 1093.29V1364.83C5566.18 1364.83 5565.19 1367.14 5563.87 1367.14H5485.67C5485.67 1367.14 5483.37 1366.15 5483.37 1364.83V1107.81C5483.37 1024.99 5450.37 990.349 5373.17 990.349C5327.3 990.349 5250.1 1023.34 5250.1 1136.51V1364.83C5250.1 1364.83 5249.11 1367.14 5247.79 1367.14H5169.59C5169.59 1367.14 5167.28 1366.15 5167.28 1364.83V928.32C5167.28 928.32 5168.27 926.01 5169.59 926.01H5242.51C5242.51 926.01 5244.82 927 5244.82 928.32V998.597C5276.16 947.127 5344.13 911.163 5400.22 911.163C5476.44 911.163 5566.51 956.035 5566.51 1092.96L5566.18 1093.29Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6023.48 1093.29V1364.5C6023.48 1364.5 6022.16 1367.14 6020.84 1367.14H5943.63C5943.63 1367.14 5940.99 1365.82 5940.99 1364.5V1108.14C5940.99 1025.32 5908 990.679 5830.79 990.679C5784.93 990.679 5707.72 1023.67 5707.72 1136.84V1364.83C5707.72 1364.83 5706.4 1367.47 5705.08 1367.47H5627.88C5627.88 1367.47 5625.24 1366.15 5625.24 1364.83V928.65C5625.24 928.65 5626.56 926.01 5627.88 926.01H5699.47C5699.47 926.01 5702.11 927.33 5702.11 928.65V998.597C5733.46 947.127 5801.43 911.163 5857.52 911.163C5933.73 911.163 6023.81 956.035 6023.81 1092.96L6023.48 1093.29Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6515.42 1111.77V1159.94C6515.42 1159.94 6514.43 1162.25 6513.11 1162.25H6154.14V1166.87C6154.14 1249.68 6190.1 1302.8 6294.69 1302.8C6370.91 1302.8 6409.51 1274.1 6424.69 1226.26C6424.69 1225.27 6425.68 1224.61 6426.67 1224.61H6508.82C6508.82 1224.61 6511.46 1225.93 6511.13 1227.25C6493.65 1332.83 6412.48 1381.66 6321.42 1381.66H6267.97C6159.42 1381.66 6073.96 1319.3 6073.96 1181.38V1111.44C6073.96 974.512 6173.27 911.163 6276.87 911.163H6311.85C6415.78 911.163 6514.76 974.512 6514.76 1111.44L6515.42 1111.77ZM6156.45 1094.28H6433.6C6433.6 1094.28 6433.6 1094.28 6433.6 1093.95C6426.01 1029.94 6393.01 990.349 6295.02 990.349C6197.03 990.349 6163.7 1029.94 6156.12 1094.28H6156.45Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6567.55 1111.77C6567.55 974.841 6657.63 911.492 6756.94 911.492H6810.39C6894.19 911.492 6967.77 959.993 6980.97 1065.57C6980.97 1067.22 6979.98 1068.54 6978.33 1068.54H6897.16C6897.16 1068.54 6894.85 1067.55 6894.52 1066.56C6883.96 1019.05 6852.62 990.348 6783.66 990.348C6683.36 990.348 6650.37 1043.8 6650.37 1126.28V1166.54C6650.37 1249.35 6683.36 1302.47 6783.66 1302.47C6858.89 1302.47 6889.57 1269.48 6897.16 1215.7C6897.16 1214.38 6898.15 1213.39 6899.47 1213.39C6910.69 1213.39 6967.11 1213.39 6979.98 1213.39C6981.63 1213.39 6982.62 1214.71 6982.62 1216.36C6973.38 1329.2 6897.49 1381.66 6810.06 1381.66H6756.61C6657.3 1381.66 6567.22 1318.31 6567.22 1181.38V1111.44L6567.55 1111.77Z",
    fill: "#1A3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7177.94 1007.87V1194.28C7177.94 1247.4 7221.17 1290.62 7274.29 1290.62H7299.36C7299.36 1290.62 7301.67 1291.61 7301.67 1292.93V1367.17C7301.67 1367.17 7300.68 1369.48 7299.36 1369.48H7247.56C7165.74 1369.48 7095.13 1324.61 7095.13 1187.68V1007.54H7032.11C7032.11 1007.54 7029.8 1006.55 7029.8 1005.23V930.989C7029.8 930.989 7030.79 928.679 7032.11 928.679H7095.13V705.31C7095.13 705.31 7096.12 703 7097.44 703H7175.31C7175.31 703 7177.62 703.99 7177.62 705.31V929.009H7299.36C7299.36 929.009 7301.67 929.999 7301.67 931.319V1005.56C7301.67 1005.56 7300.68 1007.87 7299.36 1007.87H7177.62H7177.94Z",
    fill: "#1A3127"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_478_187",
    x1: 69.092,
    y1: 1041.18,
    x2: 2176.17,
    y2: 1041.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3F200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BDF103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ACEE0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#91EA1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6BE435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#3ADC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#00D377"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_478_187",
    x1: 1836.57,
    y1: 1453.34,
    x2: 1981.67,
    y2: 1573.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00D66B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#00D163",
    stopOpacity: 0.0256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00CB5B",
    stopOpacity: 0.1296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00C753",
    stopOpacity: 0.2809
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00C24D",
    stopOpacity: 0.4624
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#00BF47",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#00BD43",
    stopOpacity: 0.7921
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#00BB41",
    stopOpacity: 0.9025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00BA3F",
    stopOpacity: 0.9801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00BA3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00BA3F",
    stopOpacity: 0.9801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00BB41",
    stopOpacity: 0.9025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#00BC44",
    stopOpacity: 0.7921
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00BF49",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#00C250",
    stopOpacity: 0.4624
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00C658",
    stopOpacity: 0.2809
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#00CA61",
    stopOpacity: 0.1296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#00CF6C",
    stopOpacity: 0.0256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00D475",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_478_187",
    x1: 545.858,
    y1: 1561.47,
    x2: 657.448,
    y2: 1469.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CEA00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98E900",
    stopOpacity: 0.0144
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#94E700",
    stopOpacity: 0.0961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8FE600",
    stopOpacity: 0.2209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8BE500",
    stopOpacity: 0.3844
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#88E400",
    stopOpacity: 0.5476
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#86E300",
    stopOpacity: 0.6889
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#84E200",
    stopOpacity: 0.8281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#82E200",
    stopOpacity: 0.9216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#82E200",
    stopOpacity: 0.9801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#82E200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#82E200",
    stopOpacity: 0.9801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#83E200",
    stopOpacity: 0.9216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#85E200",
    stopOpacity: 0.8281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#88E300",
    stopOpacity: 0.6889
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8BE400",
    stopOpacity: 0.5476
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#90E600",
    stopOpacity: 0.3844
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#95E700",
    stopOpacity: 0.2209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9BE900",
    stopOpacity: 0.0961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2EB00",
    stopOpacity: 0.0144
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7ED00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_478_187",
    x1: 142.337,
    y1: 1292,
    x2: 2440.82,
    y2: 1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3F200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BDF103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ACEE0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#91EA1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6BE435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#3ADC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#00D377"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7235.73,
    height: 1944.36,
    fill: "white",
    transform: "translate(69.096 69.096)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_478_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4537.34,
    height: 681.657,
    fill: "white",
    transform: "translate(2764.66 700)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b975fd395c6acc8746c5a1919873bf3f.svg";
export { ForwardRef as ReactComponent };